import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProvinceService {

  constructor(private httpClientService:HttpClientService) { }

  async getAllProvince(id:number){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Province,
      action:"GetAllProvince"
    },id); // bu id country id 
    return await firstValueFrom(observable);
  }
}
